<template>
    <div :class="`stockTotalChange ${getCardClass}`">{{ totalChange }}</div>
</template>

<script>
import StockHtmlHelper from './StockHtmlHelper';

export default {
    props: ['stock'],
    data() {
        return {
            stockHtmlHelper: null
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        total() {
            return this.stock.statistics.normalizedWithPreferredCurrency.totalProfitIncludingUnrealized ? this.stock.statistics.normalizedWithPreferredCurrency.totalProfitIncludingUnrealized : 0;
        },
        getCardClass() {
            return this.total < 0 ? "down" : this.total > 0 ? 'up' : '';
        },
        totalChange() {
            const symbol = this.total > 0 ? '+' : ''
            return `${symbol}${this.stockHtmlHelper.formatChange(this.total, this.stock.stockDateTimeSnapshot.price)}`
        }
    }
}
</script>

<style lang="scss" scoped>
.stockTotalChange {
    font-weight: bold;
    &.up{
        color: var(--v-greenUp-base);
    }
    &.down{
        color: var(--v-redDown-base);
    }
}
</style>